import React from "react";
import { Radio, Box, Typography, Divider, Button } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import HomeIcon from "@mui/icons-material/Home";
import { Briefcase, Buildings, House } from "@phosphor-icons/react";
import { useLocation } from "react-router";

const AddressTypeIcon = ({ type }) => {
  switch (type) {
    case "Home":
      return <House size={18} color="var(--neutral-700)" weight="bold" />;
    case "Work":
      return <Briefcase size={18} color="var(--neutral-700)" weight="bold" />;
    default:
      return <Buildings size={18} color="var(--neutral-700)" weight="bold" />;
  }
};
const CartAddressCard = ({ selected, onSelect, item, onDelete, onEdit }) => {
  const theme = useTheme();
  const location = useLocation();
  const manageAddressFlag = location.pathname.includes("my-address");

  return (
    <CardContainer selected={selected}>
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        sx={{ position: "relative" }}
        onClick={() => onSelect(item)}
      >
        <Box
          flex={1}
          sx={{
            gap: 1,
            flexDirection: "column",
            display: "flex",
            minHeight: 100,
          }}
        >
          <Box sx={{ gap: 1, display: "flex", alignItems: "center" }}>
            <IconWrapper>
              <AddressTypeIcon type={item?.address_type} />
            </IconWrapper>
            <Title>{item?.address_type}</Title>
          </Box>

          <Address>{item?.full_address}</Address>
          <PhoneNumber>
            Phone number: <strong>{`+91 ${item?.billing_mobile}`}</strong>
          </PhoneNumber>
        </Box>
        {selected && <StyledRadio checked={selected} size="small" />}
      </Box>
      {manageAddressFlag && (
        <>
          <Divider sx={{ my: 1, backgroundColor: "var(--neutral-200)" }} />
          <Footer>
            <ActionButton onClick={() => onDelete(item?.customer_address_id)}>
              Delete
            </ActionButton>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ mx: 1, backgroundColor: "var(--neutral-200)" }}
            />
            <ActionButton onClick={() => onEdit(item)}>Edit</ActionButton>
          </Footer>
        </>
      )}
    </CardContainer>
  );
};

const CardContainer = styled(Box)(({ selected, theme }) => ({
  border: `1px solid ${
    selected ? "var(--primary-red-300)" : "var(--neutral-300)"
  }`,
  borderRadius: "8px",
  padding: "10px",
  paddingBottom: "8px",
  cursor: "pointer",
  transition:
    "border 0.3s ease-in-out, box-shadow 0.3s ease-in-out, transform 0.2s ease-in-out",
  minWidth: "280px",
  "&:hover": {
    border: "1px solid var(--primary-red-300)",
    boxShadow: "0px 4px 12px rgba(12, 12, 13, 0.05)",
    transform: "scale(0.98, 0.98)",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "8px",
  },
}));

const IconWrapper = styled(Box)({
  width: 32,
  height: 32,
  backgroundColor: "white",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid var(--neutral-300)",
  alignSelf: "flex-start",
});

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 600,
  textAlign: "left",
  lineHeight: "150%",
  color: "var(--neutral-black)",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

const Address = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  fontWeight: 400,
  textAlign: "left",
  lineHeight: "157%",
  color: "var(--neutral-700)",
  textWrap: "wrap",
  wordWrap: "break-word",
  [theme.breakpoints.down("sm")]: {
    fontSize: "11px",
  },
}));

const PhoneNumber = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  fontWeight: 400,
  textAlign: "left",
  lineHeight: "167%",
  color: "var(--neutral-600)",
  "& strong": {
    fontWeight: 500,
    color: "var(--neutral-black)",
    fontSize: "13px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "11px",
    "& strong": {
      fontSize: "12px",
    },
  },
}));

const StyledRadio = styled(Radio)({
  position: "absolute",
  top: "4px",
  right: "4px",
  color: "var(--primary-red-300)",
  padding: 0,
});

const Footer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-evenly",
});

const ActionButton = styled(Button)(({ theme }) => ({
  width: "100%",
  textAlign: "center",
  textTransform: "none",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "167%",
  color: "var(--neutral-800)",
  "&:hover": {
    color: "var(--primary-red-300)",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "11px",
  },
}));

export default CartAddressCard;
